// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrEligibleExpenseDto } from './IOcrEligibleExpenseDto';
import {
    IOcrEligibleExpenseDtoFromJSON,
    IOcrEligibleExpenseDtoFromJSONTyped,
    IOcrEligibleExpenseDtoToJSON,
    IOcrEligibleExpenseDtoToJSONTyped,
} from './IOcrEligibleExpenseDto';
import type { IOcrClaimDtoWarningsInner } from './IOcrClaimDtoWarningsInner';
import {
    IOcrClaimDtoWarningsInnerFromJSON,
    IOcrClaimDtoWarningsInnerFromJSONTyped,
    IOcrClaimDtoWarningsInnerToJSON,
    IOcrClaimDtoWarningsInnerToJSONTyped,
} from './IOcrClaimDtoWarningsInner';
import type { IOcrExpenseFieldDto } from './IOcrExpenseFieldDto';
import {
    IOcrExpenseFieldDtoFromJSON,
    IOcrExpenseFieldDtoFromJSONTyped,
    IOcrExpenseFieldDtoToJSON,
    IOcrExpenseFieldDtoToJSONTyped,
} from './IOcrExpenseFieldDto';
import type { IOcrProviderDto } from './IOcrProviderDto';
import {
    IOcrProviderDtoFromJSON,
    IOcrProviderDtoFromJSONTyped,
    IOcrProviderDtoToJSON,
    IOcrProviderDtoToJSONTyped,
} from './IOcrProviderDto';
import type { IAddress } from './IAddress';
import {
    IAddressFromJSON,
    IAddressFromJSONTyped,
    IAddressToJSON,
    IAddressToJSONTyped,
} from './IAddress';
import type { IOcrFieldDto } from './IOcrFieldDto';
import {
    IOcrFieldDtoFromJSON,
    IOcrFieldDtoFromJSONTyped,
    IOcrFieldDtoToJSON,
    IOcrFieldDtoToJSONTyped,
} from './IOcrFieldDto';

/**
 * 
 * @export
 * @interface IOcrClaimDto
 */
export interface IOcrClaimDto {
    /**
     * 
     * @type {IOcrProviderDto}
     * @memberof IOcrClaimDto
     */
    provider_dto?: IOcrProviderDto;
    /**
     * 
     * @type {IAddress}
     * @memberof IOcrClaimDto
     */
    address?: IAddress;
    /**
     * 
     * @type {string}
     * @memberof IOcrClaimDto
     */
    patient?: string;
    /**
     * 
     * @type {Date}
     * @memberof IOcrClaimDto
     */
    service_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IOcrClaimDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrClaimDto
     */
    service_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrClaimDto
     */
    account?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrClaimDto
     */
    invoice?: string;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrClaimDto
     */
    patients?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrClaimDto
     */
    service_dates?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrClaimDto
     */
    amounts?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrClaimDto
     */
    service_descriptions?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrClaimDto
     */
    accounts?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrClaimDto
     */
    invoices?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrClaimDto
     */
    facility_names?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {string}
     * @memberof IOcrClaimDto
     */
    ocr_receipt_id?: string;
    /**
     * 
     * @type {Array<IOcrClaimDtoWarningsInner>}
     * @memberof IOcrClaimDto
     */
    warnings?: Array<IOcrClaimDtoWarningsInner>;
    /**
     * 
     * @type {Array<IOcrExpenseFieldDto>}
     * @memberof IOcrClaimDto
     */
    expenses?: Array<IOcrExpenseFieldDto>;
    /**
     * 
     * @type {Array<IOcrEligibleExpenseDto>}
     * @memberof IOcrClaimDto
     */
    eligible_expenses?: Array<IOcrEligibleExpenseDto>;
}

/**
 * Check if a given object implements the IOcrClaimDto interface.
 */
export function instanceOfIOcrClaimDto(value: object): value is IOcrClaimDto {
    return true;
}

export function IOcrClaimDtoFromJSON(json: any): IOcrClaimDto {
    return IOcrClaimDtoFromJSONTyped(json, false);
}

export function IOcrClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'provider_dto': json['provider_dto'] == null ? undefined : IOcrProviderDtoFromJSON(json['provider_dto']),
        'address': json['address'] == null ? undefined : IAddressFromJSON(json['address']),
        'patient': json['patient'] == null ? undefined : json['patient'],
        'service_date': json['service_date'] == null ? undefined : (new Date(json['service_date'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'service_description': json['service_description'] == null ? undefined : json['service_description'],
        'account': json['account'] == null ? undefined : json['account'],
        'invoice': json['invoice'] == null ? undefined : json['invoice'],
        'patients': json['patients'] == null ? undefined : ((json['patients'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'service_dates': json['service_dates'] == null ? undefined : ((json['service_dates'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'amounts': json['amounts'] == null ? undefined : ((json['amounts'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'service_descriptions': json['service_descriptions'] == null ? undefined : ((json['service_descriptions'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'accounts': json['accounts'] == null ? undefined : ((json['accounts'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'facility_names': json['facility_names'] == null ? undefined : ((json['facility_names'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'ocr_receipt_id': json['ocr_receipt_id'] == null ? undefined : json['ocr_receipt_id'],
        'warnings': json['warnings'] == null ? undefined : ((json['warnings'] as Array<any>).map(IOcrClaimDtoWarningsInnerFromJSON)),
        'expenses': json['expenses'] == null ? undefined : ((json['expenses'] as Array<any>).map(IOcrExpenseFieldDtoFromJSON)),
        'eligible_expenses': json['eligible_expenses'] == null ? undefined : ((json['eligible_expenses'] as Array<any>).map(IOcrEligibleExpenseDtoFromJSON)),
    };
}

export function IOcrClaimDtoToJSON(json: any): IOcrClaimDto {
    return IOcrClaimDtoToJSONTyped(json, false);
}

export function IOcrClaimDtoToJSONTyped(value?: IOcrClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_dto': IOcrProviderDtoToJSON(value['provider_dto']),
        'address': IAddressToJSON(value['address']),
        'patient': value['patient'],
        'service_date': value['service_date'] == null ? undefined : ((value['service_date']).toISOString().substring(0,10)),
        'amount': value['amount'],
        'service_description': value['service_description'],
        'account': value['account'],
        'invoice': value['invoice'],
        'patients': value['patients'] == null ? undefined : ((value['patients'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'service_dates': value['service_dates'] == null ? undefined : ((value['service_dates'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'amounts': value['amounts'] == null ? undefined : ((value['amounts'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'service_descriptions': value['service_descriptions'] == null ? undefined : ((value['service_descriptions'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'accounts': value['accounts'] == null ? undefined : ((value['accounts'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'facility_names': value['facility_names'] == null ? undefined : ((value['facility_names'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'ocr_receipt_id': value['ocr_receipt_id'],
        'warnings': value['warnings'] == null ? undefined : ((value['warnings'] as Array<any>).map(IOcrClaimDtoWarningsInnerToJSON)),
        'expenses': value['expenses'] == null ? undefined : ((value['expenses'] as Array<any>).map(IOcrExpenseFieldDtoToJSON)),
        'eligible_expenses': value['eligible_expenses'] == null ? undefined : ((value['eligible_expenses'] as Array<any>).map(IOcrEligibleExpenseDtoToJSON)),
    };
}

